export const CHECKLIST_SECTIONS = [
  {
    key: 'basicVerification',
    title: 'Basic Verification',
    items: ['Verify EMR 2022-2024', 'Review OSHA Logs and Summaries 2022-2024', 'Verify Incident Rates'],
  },
  {
    key: 'sheProgramElements',
    title: 'SH&E Program Elements',
    items: ['Resources for meeting safety, health, and environmental regulations', "Employee's participation"],
  },
  {
    key: 'legalResponsibility',
    title: 'Legal Responsibility',
    items: [
      'Ensuring employees follow safety rules of the facility',
      "Advising owner of any unique hazards presented by the contractor's work, and of any hazard found by the contractor",
    ],
  },
  {
    key: 'workPracticesProcedures',
    title: 'Work Practices & Procedures',
    items: [
      'Equipment Lockout and Tagout (LOTO)',
      'Confined Space Entry',
      'Injury & Illness Recording',
      'Fall Protection',
      'Personal Protective Equipment',
      'Portable Electrical/Power Tools',
      'Vehicle Safety',
      'Compressed Gas Cylinders',
      'Electrical Equipment Grounding Assurance',
      'Powered Industrial Vehicles (Cranes, Forklifts, JLGs)',
      'Housekeeping',
      'Accident/Incident/Unsafe Condition Reporting',
      'Emergency Preparedness, including Evacuation and Action Plans',
      'Waste Disposal/Waste Minimization/Spill Prevention',
      'Back Injury Prevention',
      'Hazwoper Training',
      'Heat Stress Prevention',
      'Scaffold Building/Scaffold Use',
      'Injury or Illness Data',
      'Written SH&E Programs',
      'Hearing Conservation',
      'Drug and Alcohol Policy',
      'Bloodborne Pathogens',
      'Mobile Equipment',
      'Access to Medical Records',
      'Benzene Awareness',
      'Arsenic Awareness',
      'Hazard Communication',
      'Heat and Cold Stress',
      'Ladder Safety',
      'Stop Work Authority',
    ],
  },
];

export const RESULT_OPTIONS = ['Yes', 'No', 'N/A'];

/** Matches API `findingType` enum */
export const FINDING_TYPE_VALUES = ['Finding', 'Recommendation', 'BestPractice', 'Comment'];

export const FINDING_TYPE_LABELS = {
  Finding: 'Finding',
  Recommendation: 'Recommendation',
  BestPractice: 'Best Practice',
  Comment: 'Comment',
};

export const FINDING_TYPE_SELECT_OPTIONS = FINDING_TYPE_VALUES.map(value => ({
  value,
  label: FINDING_TYPE_LABELS[value],
}));

export const mockOriginalAudit = {
  company: 'Hoist and Crane Service',
  originalAuditor: 'Marshall Brown',
  auditDateRange: '11/09/2025 - 11/16/2025',
  findings: [
    {
      id: 'f1',
      type: 'Finding',
      shortDescription: 'Missing OSHA 300 Log for 2024',
      issuedDate: '2025-11-09',
      targetDate: '2025-11-20',
      detailedDescription: 'Original audit identified missing OSHA 300 documentation for calendar year 2024.',
    },
    {
      id: 'f2',
      type: 'Finding',
      shortDescription: 'Incomplete incident investigation records',
      issuedDate: '2025-11-10',
      targetDate: '2025-11-22',
      detailedDescription: 'Incident investigation forms were missing root cause and corrective action details.',
    },
  ],
};
